var _style, _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvataricon06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1250.8 1249.2",
    style: {
      enableBackground: "new 0 0 1250.8 1249.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6A632;}\n\t.st1{fill:#E73964;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#F4F4F4;}\n\t.st4{fill:#A8A8A8;}\n\t.st5{fill:url(#SVGID_00000088837462187721535940000017686304781295924628_);}\n\t.st6{fill:url(#SVGID_00000018200563616663489980000007498616244066496686_);}\n\t.st7{fill:url(#SVGID_00000088815030478743461770000008477846362249024139_);}\n\t.st8{fill:url(#SVGID_00000105421731809674630620000016646748869319178884_);}\n\t.st9{fill:#EAEAEA;}\n\t.st10{fill:#F9F7F7;}\n\t.st11{fill:#A0A0A0;}\n\t.st12{fill:url(#SVGID_00000083790361710484417340000005709196814795302052_);}\n\t.st13{fill:url(#SVGID_00000178883720547212942750000017913833517115944876_);}\n\t.st14{fill:url(#SVGID_00000174578428747137497510000001385805536781833870_);}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:url(#SVGID_00000155859500783001442680000009253252436382707625_);}\n\t.st17{fill:url(#SVGID_00000078038158001876367470000011825780000247868821_);}\n\t.st18{fill:url(#SVGID_00000009582867887637597700000015938337769358361497_);}\n\t.st19{fill:url(#SVGID_00000137109336677876613970000014506680972084232361_);}\n\t.st20{fill:url(#SVGID_00000119829023360600053050000015470715123013764260_);}\n\t.st21{fill:url(#SVGID_00000175311073170046916420000009644702222333181846_);}\n\t.st22{fill:url(#SVGID_00000049199813423154381870000005690742549304958647_);}\n")), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1250.8,
    height: 1249.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.2677,
    y1: 1260.3877,
    x2: 641.2677,
    y2: 805.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    style: {
      stopColor: "#F0F0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9463,
    style: {
      stopColor: "#C1C1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M823.4,856.9c0,0,1.8,157.3,22.7,172.7c21,15.4,102.4,57.2,102.4,57.2l11.6-4.4c0,0-7-4.4,11.6,13.2 c18.6,17.6,74.5,26.4,74.5,26.4l104.8,52.8c0,0,65.2,33,65.2,46.2c0,13.2,0,13.2,0,13.2H66.3l107.1-85.7l81.5-17.6 c0,0,27.9-30.8,41.9-26.4c14,4.4,14,4.4,14,4.4l100.1-63.2c0,0,27.9-29.1,25.6-73c-2.3-44-2.3-115.5-2.3-115.5H823.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.5,642.7c0,0-23.8-65.3-22.1-93.5c8.3-135.6-15.8-135.2-19.4-146.7c-24.9-80.3-0.2-166.5,58.2-210.3 c59.1-44.4,71.8-22.1,71.8-22.1c65.3-56.5,306.4-49,325.9,26.4c9.7,37.2,31.8-26.4,67.5,0c4,2.9,0,19.8,0,19.8s72,17.2,47.4,166.9 c-24.9,152.2-5.5,182.6-22.2,191c-16.6,8.4-27.6,42.2-27.6,42.2s-4.7-265.9-79.1-263.8c-74.5,2.1-129.1,39.7-309.6,0 C431.8,343.9,359.6,590,380.5,642.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378.2,739.4c0,0-2.3,129.7,118.7,206.6c121.1,76.9,216.5,13.2,216.5,13.2s128-94.5,130.4-145.1 c2.3-50.6,21-74.7,21-74.7s14,0,23.3-11c9.3-11,11.6-81.3,18.6-101.1c7-19.8,11.6-52.8-11.6-50.6c-23.3,2.2-34.9,39.6-34.9,39.6 s4.7-61.5-9.3-101.1c-14-39.6,11.6-127.5-44.2-160.5c-55.9-33-127-22-161.3-11c-34.3,11-106.4,4.4-150.7-11 c-44.2-15.4-81.5,57.1-88.5,90.1c-7,33-30.3,167.1-27.9,193.4c2.3,26.4,2.3,26.4,2.3,26.4s-16.3-70.3-30.3-74.7 c-14-4.4-39.6-4.4-34.9,48.4c4.7,52.8,10.3,11.9,30.3,109.9C357.3,783.4,378.2,739.4,378.2,739.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165207538603040137680000011832576298267955084_",
    cx: 639.6551,
    cy: 782.0151,
    r: 727.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4799,
    style: {
      stopColor: "#F0F0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9463,
    style: {
      stopColor: "#C1C1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BABAB9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165207538603040137680000011832576298267955084_)"
    },
    d: "M1232.6,1247.6 c4.7-46.2-135.7-102.1-186.2-127.5c-50.5-25.4-88.5-48.4-109.4-57.2c-21-8.8-65.8-23.5-65.8-23.5l-8.3,13.8 c0,0-42.2,93.2-239.2,93.2c-140.5,0-212.7-102.8-212.7-102.8c-44.3,12.7-144.7,57.4-163,74.2c-18.2,16.8-38.5,27.4-60.9,25.6 c-25.8-2-119.5,87.6-140.3,104.1H1232.6z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364,588c0,0,16.6,119,13.9,138.4c-2.8,19.4-11.1,77.5-2.8,130.1c8.3,52.6,27.7,113.5,52.6,138.4 c24.9,24.9,63.7,55.3,63.7,55.3s-2.8-8.3,0-13.8c2.8-5.5,2.8,22.1,11.1,33.2c8.3,11.1,52.6,13.8,52.6,13.8s80.4,27.7,110.8,2.8 c0,0,11.1,11.1,27.7,0c16.6-11.1,105.3-33.2,121.9-94.1c0,0,41.6-96.9,44.3-166c2.8-69.2,0-91.3,0-91.3s-2.8-121.8,8.3-141.1 c11.1-19.4-5.5-19.4-5.5-19.4s-13.9,63.6-13.9,88.6c0,24.9-19.4,119-41.6,130.1c-22.2,11.1-73.2,38.6-121.9,66.4 c-19.4,11.1-105.3,5.5-127.5,0c-38.5-9.6-36-41.5-83.1-55.3c0,0-74.8-19.4-77.6-41.5c-2.8-22.1-22.2-138.4-22.2-188.2 C375.1,524.3,364,588,364,588z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M623.4,753.3c-6.2,1.7-12.6,1.7-18.7-0.4c-15.3-5.2-43.9-10.9-74.5,3.4c-38.3,17.9-33.3,49.8-80.4,41.5 c-47.1-8.3-41.6-8.3-41.6-8.3s11.1,33.2,36,44.3c24.9,11.1,122.1-18.8,138.5-24.9c30.5-11.4,80.4,0,80.4,0s69.3,31,110.8,25.4 c41.6-5.5,63.7-44.3,63.7-44.3s-52.6,30.4-80.4,16.6c-27.7-13.8-44.3-53.5-74.8-56.3C661.4,748.4,637.5,749.4,623.4,753.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvataricon06);
export default __webpack_public_path__ + "static/media/avatar icon-06.ce1bb6db05a30a8b6758368036371df6.svg";
export { ForwardRef as ReactComponent };